export default {
  setSavedApplicationId(state, payload) {
    if (payload)
      window.localStorage.setItem('savedSupplierApplicationId', payload);
    else window.localStorage.removeItem('savedSupplierApplicationId');
    state.savedApplicationId = payload;
  },
  setId(state, payload) {
    state.id = payload;
  },
  setStep(state, { stepName, step }) {
    state[stepName] = step;
  },
  setStepIsCompleted(state, { stepName, step }) {
    state[stepName].isCompleted = step;
  },
  setApplication(state, payload) {
    const { id, currentStatus, segment } = payload;
    const {
      intro,
      questions,
      companyInformation,
      contactInformation,
      contract,
    } = payload.steps;

    state.id = id;
    state.currentStatus = currentStatus;
    state.segment = segment;
    state.intro = intro;
    state.questions = questions;
    state.companyInformation = companyInformation;
    state.contactInformation = contactInformation;
    state.contract = contract;
  },
  setSegment(state, { segment = 'starter' }) {
    state.segment = segment;
  },
  resetApplication(state) {
    const {
      intro,
      questions,
      companyInformation,
      contactInformation,
      contract,
    } = state.defaultSteps;

    state.id = null;
    state.currentStatus = 'new';
    state.intro = intro;
    state.questions = questions;
    state.companyInformation = companyInformation;
    state.contactInformation = contactInformation;
    state.contract = contract;
  },
};
